<template lang="pug">
#search-wrap(:class="classObject")
  template(v-if="isTouchSearch")
    #mobile-search(@click="startTouchSearch" v-if="!isSearching")
      icon(data="~@/assets/svg/small-plus.svg" :fill="false")
      span New like

  input#search-box.input(
    v-if="!isTouchSearch || isSearching"
    autocomplete="none"
    ref="searchBox"
    type="text"
    placeholder="What do you like?"
    v-model.trim="query"
    @keydown.backspace="filterQuery"
    @input="filterQuery"
    @keydown.esc="close"
    @keyup.enter="performSearch"
    @keydown.prevent.down="directionHandler('down')"
    @keydown.prevent.up="directionHandler('up')"
  )

  font-awesome-icon#mobile-close(:icon="['fas', 'times']" @click="close" v-if="isSearching")

  #search-results(v-if="showResults"  :style="{width: `${srWidth}px`}" v-closeable="{exclude: ['$el'] ,handler: 'close'}")
    .search-result(
      v-for="(interest, index) in results"
      :key="interest.id"
      tabindex="0"
      :data-index="index"
      :class="{ 'active':  resultActive(interest)}"
      @click="gotoInterest(interest)"
    ) {{ interest.name }}

    .search-result.search-create(v-if="createInterest" @click="performSearch")
      | Create:
      span  {{ this.query }}
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  props: {},

  data() {
    return {
      createInterest: false,
      currentSelection: null,
      isSearching: false,
      isTouchSearch: false,
      navigatedIndex: -1,
      query: null,
      results: [],
      srWidth: 303,
      showResults: false,
    }
  },

  computed: {
    debounceOnInput: () => {
      return debounce(async function () {
        await this.searchInterests()
      }, 250)
    },
    classObject,
    // isTouchSearch,
  },

  watch: {
    '$breakpoint.isPhone': {
      immediate: true,
      handler(value) {
        this.close()
        this.isTouchSearch = value
      },
    },
  },

  methods: {
    close,
    filterQuery,
    gotoInterest,
    performSearch,
    resultActive,
    searchInterests,
    startTouchSearch,

    // Handle up/down arrows
    directionHandler,
  },

  components: {},
}

/* Computed ---------------------------------------------------- */
function classObject() {
  return {
    'touch-active': this.isSearching,
  }
}

function isTouchSearch() {
  return this.$breakpoint.isTouch
}
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
function close() {
  this.showResults = false
  this.query = null
  this.results = []
  this.createInterest = false
  this.isSearching = false

  if (this.popper) {
    this.popper.destroy()
    this.popper = null
  }

  if (this.$refs.searchBox) this.$refs.searchBox.blur()
}

function filterQuery() {
  this.debounceOnInput()
}

function gotoInterest(interest) {
  this.close()
  if (this.$route.params.slug != interest.slug) {
    this.$router.push({ name: 'interestPage', params: { slug: interest.slug } })
  }
}

async function performSearch() {
  if (this.currentSelection) {
    this.gotoInterest(this.currentSelection)
  } else if (!this.createInterest) {
    this.gotoInterest(this.results[0])
  } else {
    const interest = await this.$store.dispatch('interests/create', this.query)

    this.close()
    this.$router.push({ name: 'interestPage', params: { slug: interest.slug } })
  }
}

function resultActive(interest) {
  return this.currentSelection?.id == interest.id
}

async function searchInterests() {
  this.showResults = true

  if (/\p{Emoji}/u.test(this.query) || this.query?.length >= 2) {
    this.results = await this.$store.dispatch('interests/search', {
      query: this.query,
    })

    this.srWidth = this.$refs.searchBox.offsetWidth

    this.createInterest =
      this.results.filter(r => r.name.toLowerCase() === this.query.toLowerCase())?.length == 0
  }
}

function startTouchSearch() {
  this.isSearching = true
  console.log('Search.vue :132', 'startTouchSearch')
}

function directionHandler(direction = 'down') {
  if (direction == 'down') {
    this.navigatedIndex = (this.navigatedIndex + 1) % this.results.length
  } else {
    this.navigatedIndex = this.navigatedIndex == -1 ? 0 : this.navigatedIndex
    this.navigatedIndex = (this.navigatedIndex + this.results.length - 1) % this.results.length
  }

  this.currentSelection = this.results[this.navigatedIndex]

  const el = document.body.querySelector(`.search-result[data-index="${this.navigatedIndex}"]`)

  if (el) el.scrollIntoView(false)
}
</script>
